import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import { UserContext } from '@mirinae/react-auth';
import { fontDefaultAlt } from '@mirinae/react-ui';

import GlobalContext from '@mirinae/lessons/modules/contexts/global';
import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { LessonButton } from '@mirinae/lessons/modules/defines/styles';
import { lessonsPalette } from '@mirinae/lessons/modules/defines/styles';

const Button = styled(LessonButton)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border-radius: 25px;
    color: ${lessonsPalette.primary.white};
    font-family: ${fontDefaultAlt};
    font-weight: 700;
    font-size: 18px;
    text-transform: capitalize;
    background-color: ${props => (props.theme === 'start' ? lessonsPalette.default[0] : '#A0C991')}; // startButton or finishButton
    &:hover:not(:disabled) {
        background-color:  ${props => (props.theme === 'start' ? lessonsPalette.darken[0] : '#6DAA57')};
    }
    &:disabled {
        background-color: ${lessonsPalette.grey[5]};
    }
`;

const StartFinishButton = ({ element }) => {
    const [userContext] = useContext(UserContext);
    const player = useContext(PlayerContext);
    const start = element.componentName === 'startButton';
    
    const handleClick = () => {
        if (userContext.user?.role === 'guest') {
            player.update({ displayLoginPopup: true });
            return;
        }

        if (start) {
            player.next();
        } else { 
            player.finish();
        }
    };

    return (
        <Element element={element}>
            <Button data-t="lesson-continue-btn" type="button" theme={start && 'start'} onClick={handleClick}>
                {(element.fieldsByName.label && element.fieldsByName.label.value) || 'start'}
            </Button>
        </Element>
    );
};

export default StartFinishButton;
